export default class AcceptInvite {
  constructor ({ id = null, target_id = null, target_type = null, invite_token = null } = {}) {
    this.id = id
    this.target_id = target_id
    this.target_type = target_type
    this.invite_token = invite_token
  }
}
